import React from 'react';
import { TFunction, withTranslation } from 'react-i18next';
import 'react-toastify/dist/ReactToastify.css';
import { TerminalsService } from '../../services/TerminalsService';
import { IGetRollOrdersFilter, IRollOrderResponse } from '../../requests/IRollOrderRequest';
import { AxiosResponse } from 'axios';
import Page from '../containers/page';
import Card from '../containers/card';
import RollReport from './RollReport';
import SideModal from '../containers/side-modal';
import NpsSurvey from './NpsSurvey';
import Pagination from '../Pagination';
import './RollsRequest.scss';

interface IProps {
    t: TFunction;
}

interface IState {
    allRollOrders: IRollOrderResponse[];
    showRollReportModal: boolean;
    showNpsModal: boolean;
    rollOrderId: string;
    activePage: number;
    mainPage: number;
    loading: boolean;
}

const PAGE_SIZE = 10;
const PAGE_QUANTITY = 5;

const T_PREFIX: string = 'pages.rollRequest.';

class RollsRequest extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            allRollOrders: [],
            showRollReportModal: false,
            showNpsModal: false,
            rollOrderId: '',
            activePage: 1,
            mainPage: 0,
            loading: false,
        };
    }

    componentDidMount() {
        this.loadRollOrders();
    }

    loadRollOrders() {
        this.setState({ loading: true });
        const filter: IGetRollOrdersFilter = { skip: 0, take: 0 };
        TerminalsService.getRollOrders(filter)
            .then((response: AxiosResponse<IRollOrderResponse[]>) => {
                this.setState({
                    allRollOrders: response?.data ?? [],
                    activePage: 1,
                    mainPage: 0,
                    loading: false,
                });
            })
            .catch(() => this.setState({ loading: false }));
    }

    render() {
        const { t } = this.props;
        const { allRollOrders, activePage, mainPage, loading } = this.state;

        const startIndex = (activePage - 1) * PAGE_SIZE;
        const displayedOrders = allRollOrders.slice(startIndex, startIndex + PAGE_SIZE);

        const groupStartItem = mainPage * PAGE_QUANTITY * PAGE_SIZE;
        const remainingItems = allRollOrders.length - groupStartItem;
        const dataL = remainingItems > PAGE_QUANTITY * PAGE_SIZE
            ? PAGE_QUANTITY * PAGE_SIZE + 1
            : remainingItems;

        return (
            <Page>
                <>
                    <div className="row">
                        <h2>{t(`${T_PREFIX}title`)}</h2>
                        <div className="col-lg-12">
                            <>
                                <div className="row">
                                    <div className="col-md-10"></div>
                                    <div className="col-md-2 mb-4">
                                        <div className="d-flex justify-content-end">
                                            <button color="primary" className="buttonStepNext" onClick={() => this.setState({ showRollReportModal: true })}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                    <path d="M15.8327 10.8333H10.8327V15.8333H9.16602V10.8333H4.16602V9.16667H9.16602V4.16667H10.8327V9.16667H15.8327V10.8333Z" fill="white"/>
                                                </svg>
                                                {t(`${T_PREFIX}newRequest`)}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <Card title={t(`${T_PREFIX}cardTitle`)}>
                                    <>
                                    <table className="roll-history-table">
                                        <thead>
                                            <tr>
                                                <th>Fecha</th>
                                                <th>Número de pedido</th>
                                                <th>Estado</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {loading ? (
                                                <tr><td colSpan={3} className="text-center">Cargando...</td></tr>
                                            ) : displayedOrders.length === 0 ? (
                                                <tr><td colSpan={3} className="text-center">Sin resultados.</td></tr>
                                            ) : displayedOrders.map(row => {
                                                const dateFormatted = new Date(row.createdAt).toLocaleDateString('es-AR', { day: '2-digit', month: '2-digit', year: 'numeric' });
                                                const statusClass = row.status === 'Entregado' ? 'delivered' : row.status === 'En camino' ? 'transit' : 'pending';
                                                return (
                                                    <tr key={row.id}>
                                                        <td>{dateFormatted}</td>
                                                        <td>{row.orderId}</td>
                                                        <td>
                                                            <span className={`roll-status roll-status--${statusClass}`}>
                                                                {row.status}
                                                            </span>
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                    <Pagination
                                        dataL={dataL}
                                        mainPage={mainPage}
                                        pageSize={PAGE_SIZE}
                                        pageQuantity={PAGE_QUANTITY}
                                        activePageProp={activePage}
                                        changePage={(page: number) => this.setState({ activePage: page })}
                                        modifyMainPage={(sign: number) => this.setState(prev => ({ mainPage: prev.mainPage + sign }))}
                                    />
                                    </>
                                </Card>
                                <SideModal
                                    show={this.state.showRollReportModal}
                                    onClose={() => this.setState({ showRollReportModal: false })}
                                    title={t(`${T_PREFIX}requestRolls`)}
                                    width={'50vw'}
                                >
                                    <RollReport
                                        onClose={() => this.setState({ showRollReportModal: false })}
                                        onOrderComplete={(orderId: string) => {
                                            const last = localStorage.getItem('nps_last_submitted');
                                            const daysSince = last ? (Date.now() - Number(last)) / (1000 * 60 * 60 * 24) : Infinity;
                                            const showNps = daysSince >= 90;
                                            this.setState({ showRollReportModal: false, showNpsModal: showNps, rollOrderId: orderId });
                                            this.loadRollOrders();
                                        }}
                                    />
                                </SideModal>
                                {this.state.showNpsModal && (
                                    <NpsSurvey eventId={this.state.rollOrderId} onClose={() => this.setState({ showNpsModal: false })} />
                                )}
                            </>
                        </div>
                    </div>
                </>
            </Page>
        );
    }
}

export default withTranslation()(RollsRequest);